import React, { useState } from "react"
import { Marker } from "react-map-gl"
import { IconType } from "react-icons"
import { ICON_MAP } from "../constants"
import { IconMarkerProps } from "../../../types"

const IconMarker: React.FC<IconMarkerProps> = ({ latitude, longitude, category, isSelected, onClick, onMouseEnter, onMouseLeave }) => {
  const [hovering, setHovering] = useState(false)

  const normalizedCategory = category?.toLowerCase().trim()
  const IconComponent: IconType = ICON_MAP[normalizedCategory] || ICON_MAP.food

  return (
    <Marker longitude={longitude} latitude={latitude} anchor="center">
      <div
        className={`marker icon ${isSelected ? "selected" : ""} ${hovering ? "hover" : ""}`}
        onClick={onClick}
        onMouseEnter={() => {
          setHovering(true)
          onMouseEnter?.()
        }}
        onMouseLeave={() => {
          setHovering(false)
          onMouseLeave?.()
        }}
      >
        <IconComponent />
      </div>
    </Marker>
  )
}

export default IconMarker
